var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('center',[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo-404.png")}}),_c('br'),_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v(" The page you were looking for does not exist. ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }